import { DEFALUT_PERMISSION_SECTION } from '@model';

/**
 * Maps the current route to a module permission key (same as customizeModule[].value).
 * When null, callers should treat the page as not mapped and allow chat if the project is on.
 *
 * @param {string} pathname
 * @param {string} [search] — location.search
 * @returns {string | null}
 */
export function resolveAiChatModuleKey(pathname, search = '') {
  if (!pathname) {
    return null;
  }

  const q = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(q);
  const from = params.get('from');
  const integrationModuleId = params.get('integrationModuleId');
  if (from === 'tiles' && integrationModuleId) {
    return integrationModuleId;
  }

  const moduleValue = params.get('moduleValue');
  if (moduleValue) {
    return moduleValue;
  }

  const p = pathname.toLowerCase();

  if (p.includes('project-detail')) {
    return 'Home';
  }

  if (p.includes('analysis')) {
    return DEFALUT_PERMISSION_SECTION.ANALYSIS;
  }

  if (p.includes('insights')) {
    return DEFALUT_PERMISSION_SECTION.INSIGHT;
  }

  if (p.includes('questionnaires')) {
    return DEFALUT_PERMISSION_SECTION.QUESTIONNAIRE;
  }

  if (p.includes('managetiles')) {
    return 'manageTiles';
  }

  return null;
}
